import { Component, OnInit, OnDestroy } from '@angular/core';
import { FirebaseUISignInSuccessWithAuthResult } from 'firebaseui-angular';
import { Router } from '@angular/router';
import { AuthService } from '../shared/auth.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {

  private subscriptions = new Subscription();

  constructor(private router: Router, private authService: AuthService) { }

  ngOnInit() {
  }

  signInSuccess(data: FirebaseUISignInSuccessWithAuthResult) {
    this.subscriptions.add(this.authService.getUser().subscribe(user => {
      if (user) {
        this.router.navigate(['activities']);
      }
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
